import React from 'react';
import Rating from '@mui/material/Rating';
import { FormattedMessage } from '../../util/reactIntl';
import { IconReviewStar, Reviews } from '../../components';

import css from './ListingPage.module.css';
import classNames from 'classnames';

const SectionReviews = props => {
  const { publicData, subscriptionLevelToLow } = props;

  const votes = publicData?.dedicatedVotes || [];
  const votesWithRating = votes.map(r => r.rating);
  const totalVotes = publicData?.totalVotes || 0;
  const votesAvg = publicData?.votesAvg;

  const reviews = publicData?.dedicatedReviews || [];
  const reviewsWithRating = reviews
    .filter(r => r.attributes.rating)
    .map(r => r.attributes.rating);

  const totalReviews = publicData?.totalReviews || 0;
  const reviewsSum = reviewsWithRating.reduce((a, b) => a + b, 0);
  const reviewsAvg = (reviewsSum / totalReviews).toFixed(1);

  return (
    <div className={css.sectionTotalReviews}>
      {!!parseInt(reviewsAvg) ? (
        <div className={css.totalReview}>
          <Rating
            name="read-only-rating"
            className={css.rating}
            value={reviewsAvg}
            precision={0.1}
            readOnly
          />
          <span className={css.label}>{totalReviews > 1 ? `(${totalReviews} reviews)` : `(${totalReviews} review)`}</span>
        </div>
      ) : !!parseInt(votesAvg) ? (
        <div className={css.totalReview}>
          <Rating
            name="read-only-rating"
            className={css.rating}
            value={votesAvg}
            precision={0.1}
            readOnly
          />
          <span className={css.label}>{totalVotes > 1 ? `(${totalVotes} votes)` : `(${totalVotes} vote)`}</span>
        </div>
      ) : null}
    </div>
  );
};

export default SectionReviews;
